export default function CtaData(partner, isContactSpecialist) {
  return [
    {
      iconName: "m_bookSpark",
      value: `Quality experience<br> is the ${partner} <i>Difference</i>`,
      buttonText: isContactSpecialist ? "Contact a Specialist" : "See Your Quotes",
      action: "",
      backgroundImageUrl: "https://assets.covrtech.com/Consumer/landing-assets/term_3_1/service_smile.webp",
    },
    {
      iconName: "m_shieldwithHeart",
      value: "Protect your family<br>with Term Life Insurance",
      buttonText: isContactSpecialist ? "Contact a Specialist" : "See Your Quotes",
      action: "",
      backgroundImageUrl: "https://assets.covrtech.com/Consumer/landing-assets/term_3_1/family_feet.webp",
    },
  ];
};
